import { PROJECT_CODE } from '../../constants/project';


/**
 * The class for the search interface.
 */
export const CLASS_SEARCH = `${ PROJECT_CODE }__search`;

/**
 * The class for the replace interface.
 */
export const CLASS_REPLACE = `${ PROJECT_CODE }__replace`;

/**
 * The class for controls in the search interface.
 */
export const CLASS_SEARCH_CONTROLS = `${ CLASS_SEARCH }__controls`;

/**
 * The class for controls in the replace interface.
 */
export const CLASS_REPLACE_CONTROLS = `${ CLASS_REPLACE }__controls`;

/**
 * The class for displaying matches count.
 */
export const CLASS_MATCHES_COUNT = `${ CLASS_SEARCH }__matches`;
